<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []
    if (icon !== 'false') {
      vnodes.push(<span slot='title' class="sub-title"><svg-icon icon-class={icon}/>{(title)}</span>)
    } else {
      vnodes.push(<span slot='title' class="sub-title"><span class='active-flag'></span>{(title)}</span>)
    }
    // if (icon) {
    //   vnodes.push(<svg-icon icon-class={icon}/>)
    // }

    // if (title) {
    //   vnodes.push(<span slot='title'>{(title)}</span>)
    // }
    return vnodes
  }
}
</script>
<style scoped>
.sub-title {
  display: flex;
  align-items: center;
}
.active-flag {
  display: inline-block;
  width: 4px;
  height: 12px;
  border-radius: 2px;
  background-color: transparent;
  margin-right: 8px;
}
</style>
